import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import {  DeleteSponserImageDTO, EventsApiService } from 'features/events';
import i18n from 'locales/i18n';
import { queryClient } from 'providers';

import { eventsQueryKeys } from './query-keys';

const { deleteeventssponsor } = EventsApiService();

export const useDeleteSponserEventImage = () => {
  const { message } = App.useApp();

  return useMutation(
    (payload: DeleteSponserImageDTO) => {
      return deleteeventssponsor(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        console.error(uiMessage);
        message.error(i18n.t('events.update.errorCoverImageDelete'));
      },
      onSuccess: (_, variables) => {
        Promise.all([
          queryClient.invalidateQueries({
            queryKey: eventsQueryKeys.lists(),
          }),
          queryClient.invalidateQueries({
queryKey: eventsQueryKeys.detail(variables.sponsorId.toString()),          }),
        ]);
        // message.success(i18n.t('events.update.successfulCoverImageDelete'));
      },
    },
  );
};
